import {Injectable} from '@angular/core';
import {ByTokenActivateGuardService} from '@abstract/guards/by-token-activate.guard.service';

@Injectable()
export class ActivateInvitedUserService extends ByTokenActivateGuardService {
    tokenCheckUrl = 'user/validate-activation-token';
}
